import EditMyProfile from '@efdigital/ll-xceed-v2/components/coaching/coach/edit-my-profile';
import type { CoachingCoachSettingsIndexModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/settings/index';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface IndexSignature {
  Args: {
    model: CoachingCoachSettingsIndexModel;
    controller: unknown;
  };
}

export default class CoachingCoachSettingsIndex extends Component<IndexSignature> {
  @service declare router: RouterService;

  // Reload published/pending after the coach submits a change request.
  refresh = () => {
    this.router.refresh('coaching.coach.settings.index');
  };

  <template>
    {{pageTitle "Profile"}}
    <div class="{{PAGE_WRAPPER_CONTENT}} ll-coach-settings">
      <EditMyProfile
        @published={{@model.published}}
        @pending={{@model.pending}}
        @onSaved={{this.refresh}}
      />
    </div>
  </template>
}
